import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import GlJournalQueryBuilderService from "services/Setup/Jurnal/GlJournalQueryBuilderService";

export const initialState = {
  loading: false,
  error: null,
  glJournalQueryBuilderList: [],
  glJournalQueryBuilderCount: 0,
  selectedGlJournalQueryBuilder: null,
};

const toListAndCount = (response) => {
  const payload = response?.data;
  if (payload && Array.isArray(payload.data)) {
    return { list: payload.data, count: payload.count ?? payload.data.length };
  }
  if (Array.isArray(payload)) return { list: payload, count: payload.length };
  return { list: [], count: 0 };
};

export const getGlJournalQueryBuilderList = createAsyncThunk(
  "glJournalQueryBuilder/getGlJournalQueryBuilderList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GlJournalQueryBuilderService.getGlJournalQueryBuilderList(params);
      return toListAndCount(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addGlJournalQueryBuilder = createAsyncThunk(
  "glJournalQueryBuilder/addGlJournalQueryBuilder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GlJournalQueryBuilderService.addGlJournalQueryBuilder(data);

      if (response.status === 200) {
        const body = response.data;
        notification.success({
          message: body?.status || "Success",
          description: body?.message || "Query builder berhasil ditambahkan",
          duration: 3,
        });
        return body;
      }

      notification.error({ message: "Error", description: "Unexpected response!", duration: 3 });
      return rejectWithValue(response?.data);
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Gagal menyimpan query builder!",
        duration: 3,
      });
      return rejectWithValue(error.response?.data);
    }
  }
);

const GlJournalQueryBuilderSlice = createSlice({
  name: "glJournalQueryBuilder",
  initialState,
  reducers: {
    setSelectedGlJournalQueryBuilder: (state, action) => {
      state.selectedGlJournalQueryBuilder = action.payload;
    },
    clearSelectedGlJournalQueryBuilder: (state) => {
      state.selectedGlJournalQueryBuilder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGlJournalQueryBuilderList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGlJournalQueryBuilderList.fulfilled, (state, action) => {
        state.loading = false;
        state.glJournalQueryBuilderList = action.payload.list;
        state.glJournalQueryBuilderCount = action.payload.count;
      })
      .addCase(getGlJournalQueryBuilderList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Gagal memuat daftar query definition";
      })

      .addCase(addGlJournalQueryBuilder.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGlJournalQueryBuilder.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addGlJournalQueryBuilder.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setSelectedGlJournalQueryBuilder,
  clearSelectedGlJournalQueryBuilder,
} = GlJournalQueryBuilderSlice.actions;

export default GlJournalQueryBuilderSlice.reducer;
